import React, { useEffect, useState } from 'react';
import Button_mui from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { LearnStatType } from '../../../Constant';

type LearnResultButtonProps = {
  learnStat: LearnStatType;
  cv_v?: number;
  cv_c?: number;
  onClick: () => void;
};

/**
 * 学習結果	ボタン
 * @param props
 * @returns
 */
const IoTDevListLearnResultButton: React.FC<LearnResultButtonProps> = (props) => {
  const { t } = useTranslation();
  const [learnStat, setLearnStat] = useState<LearnStatType>(props.learnStat);
  const [cvv, setCvv] = useState<number | undefined>(props.cv_v);
  const [cvc, setCvc] = useState<number | undefined>(props.cv_c);

  useEffect(() => {
    setLearnStat(props.learnStat);
    setCvv(props.cv_v);
    setCvc(props.cv_c);
  }, [props.learnStat, props.cv_v, props.cv_c]);

  const getLearnResultButtonColor = (state?: LearnStatType): string => {
    if (state == undefined) return 'silver';

    switch (state) {
      /* 学習前*/
      case LearnStatType.BEFORE_LEARNING:
        return 'green';
      /* 学習中 */
      case LearnStatType.LEARNING:
        return 'royalblue';
      /* 学習後(ばらつき有)*/
      case LearnStatType.AFTER_LEARNING_VARIATION:
        return 'red';
      /* 学習後(ばらつき無)*/
      case LearnStatType.AFTER_LEARNING_NO_VARIATION:
        return 'orange';
      /**使用不可 */
      case LearnStatType.UNUSABLE:
        return 'silver';
      default:
        return 'silver';
    }
  };

  /**
   * ボタン表示判定
   * @param state
   * @returns
   */
  const isButtonEnable = (state?: LearnStatType, cv_c?: number, cv_v?: number): boolean => {
    //どちらかのデータが有ればボタンは表示

    if (cv_c === null && cv_v === null) return false;

    //if (state == undefined) return false;

    switch (state) {
      /* 学習後(ばらつき有)*/
      case LearnStatType.AFTER_LEARNING_VARIATION:
        return true;
      /* 学習後(ばらつき無)*/
      case LearnStatType.AFTER_LEARNING_NO_VARIATION:
        return true;
    }
    return true;
  };

  //console.debug(['- 画面描画開始 -', props]);
  return (
    <div>
      {isButtonEnable(learnStat, cvc, cvv) ? (
        <Button_mui
          variant="outlined"
          style={{
            borderColor: getLearnResultButtonColor(learnStat),
            color: getLearnResultButtonColor(learnStat),
            width: '130px',
          }}
          onClick={() => {
            props.onClick();
          }}
        >
          {t('IoTDevListGrid.表示', '表示')}
        </Button_mui>
      ) : null}
    </div>
  );
};

export default IoTDevListLearnResultButton;
